import { render, staticRenderFns } from "./NewMatrixName.vue?vue&type=template&id=fc7b8fe8&"
import script from "./NewMatrixName.vue?vue&type=script&lang=js&"
export * from "./NewMatrixName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports